import React from 'react'
import { Track, Fill } from './styles'

export const ProgressBar = ({ value, height = 8, borderRadius = 4, color, bgColor }) => (
  <Track $height={height} $borderRadius={borderRadius} $bgColor={bgColor}>
    <Fill $value={Math.min(100, Math.max(0, value))} $color={color} $borderRadius={borderRadius} />
  </Track>
)
